export class textFunctions {
    constructor() { }
    formatNameLastname(value) {
        value = value
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        let text = value.trim().split(/\s+/);
        let firstValue = text[0] || '';
        let secondValue = text[1] || '';
        firstValue =
            firstValue.charAt(0).toUpperCase() +
                firstValue.slice(1).toLowerCase();
        secondValue = secondValue
            ? secondValue.charAt(0).toUpperCase() +
                secondValue.slice(1).toLowerCase()
            : '';
        return `${firstValue}${secondValue ? ' ' + secondValue : ''}`;
    }
    formatText(texto) {
        let formattedText = texto
            .normalize('NFD')
            .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, '$1')
            .normalize()
            .toLowerCase();
        return formattedText;
    }
}
